<script lang="ts">
	import { _ } from 'svelte-i18n';
	import DatePickerInput from '$lib/components/DatePicker/DatePickerInput.svelte';
	import Select from 'svelte-select';

	export let placeholder: string;
	export let value: string;
	export let label: string;
	export let custom = false;
	export let name: string;
	export let setFields: (fieldName: string, value: string) => void;

	let items = [
		{ label: $_('hubs.post.settings.date.auto'), value: 'auto' },
		{ label: $_('hubs.post.settings.date.custom'), value: 'custom' },
	] as const;
	let selected = custom ? items[1] : items[0];

	$: setFields(name, value);
</script>

<div>
	{label}
	<div class="innerContainer">
		<Select showChevron={true} clearable={false} bind:value={selected} {items} />
		{#if selected.value === 'custom'}
			<DatePickerInput bind:value setMaxDate />
		{/if}
	</div>
	{placeholder}
</div>

<style>
	.innerContainer {
		display: grid;
		grid-gap: var(--gutterSmaller);
		grid-template-columns: 1fr 1fr;
		margin-block: var(--gutterSmaller);
	}

	.innerContainer :global(.wrapper) {
		background-color: white; /* makes the date input field white, unsure why this is not the default */
	}
</style>
